module.exports = __webpack_public_path__ + "img/big.4159da99.jpg";